import React from 'react'
import LayoutContainer from '../../views/layouts/LayoutContainer'
import Navbar from '../navbar/Navbar'

export default ({ children }) => (
  <div>
    <Navbar to="/mobile" />
    <div className="container">
      <div className="section">{children}</div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/templates/mobileForm/MobileFormLayout.js